import React from 'react';

export const ProgressBar = (props) => {
    const text = !!props && !!props.text ? props.text : "Загрузка...";
    return (
        <div className='rdev_progressbar'>
            <h3 className='rdev_progressbar__title'>{text}</h3>
        </div>
    );
} 